module.exports = __webpack_public_path__ + "static/img/egg_r_09.77cd40d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_09.png
// module id = Bl51
// module chunks = 1